import {Button} from "@mui/material";
import React from "react";
import useRedirectToLogin from "@/hooks/useRedirectToLogin";

export default function ProductLoginButton () {
    const redirectToLogin = useRedirectToLogin()

    return (
        <>
            <Button
                disableElevation
                variant = "outlined"
                size = "small"
                onClick = {e => {
                    redirectToLogin()
                }}
            >

                ورود
            </Button >
        </>
    );
};